import {IEnvironment} from '../../../../environments/ienvironment';
import {GO_MENU} from './go.menu';
import {GETPAID_MENU} from './getPaid.menu';
import {MenuItem} from './menu-item';

export {MenuItem, MenuLink, MenuExternal, MenuGroup, MenuDivider, MenuContext} from './menu-item';
export {GO_MENU} from './go.menu';
export {GETPAID_MENU} from './getPaid.menu';

export function resolveSideMenu(env: IEnvironment): MenuItem[]
{
    return env.instanceName === 'GetPaid' ? GETPAID_MENU : GO_MENU;
}
